import { makeStylesV5 } from '../index';
export default makeStylesV5()((theme) => ({
    droppableBox: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    draggableBox: {
        border: '1px solid',
        borderColor: theme.palette.border.main,
        backgroundColor: '#fff',
        borderRadius: 4,
        padding: 35,
        paddingLeft: 0,
        position: 'relative',
        marginBottom: 24,
        '&.box-dragging': {
            border: `2px solid ${theme.palette.primary.main}`,
            boxShadow: '-10px 10px 6px #0000002C',
        },
        '& .drag-handle-box': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        '& .drag-action-box': {
            position: 'absolute',
            top: 0,
            right: 0,
        }
    },
    customPlaceholder: {
        position: 'absolute',
        borderRadius: 4,
        background: '#F2F3F4',
    },
}));
//# sourceMappingURL=styles.js.map